/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Institutionother1Inputs */

const en__field_institutionother1 = /** @type {(inputs: _Field_Institutionother1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other institution`)
};

const de__field_institutionother1 = /** @type {(inputs: _Field_Institutionother1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige Institution`)
};

/**
* | output |
* | --- |
* | "other institution" |
*
* @param {_Field_Institutionother1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_institutionother1 = /** @type {((inputs?: _Field_Institutionother1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Institutionother1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_institutionother1(inputs)
	return de__field_institutionother1(inputs)
});
export { _field_institutionother1 as "_field_institutionOther" }